import React from "react"
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"

const SectionDivider = (props) => {
	return (
		<Box boxShadow={2} bgcolor={"lightblue"}>
			<Typography align="center" variant="h6">
				{props.text}
			</Typography>
		</Box>
	)
}

export default SectionDivider
